import type { CSSProperties, ReactNode } from "react";
import { Pill } from "./Pill";

interface SectionHeadProps {
  eyebrow: ReactNode;
  title: ReactNode;
  sub?: ReactNode;
  className?: string;
}

const stagger = (i: number) => ({ "--i": i }) as CSSProperties;

// Section header: eyebrow pill + h2 + sub. Each child carries data-r with a --i stagger index
// (the reveal CSS only hides them when <html> has the JS-set `anim` class — SSG-safe).
export function SectionHead({ eyebrow, title, sub, className }: SectionHeadProps) {
  return (
    <div className={`sec-head${className ? " " + className : ""}`}>
      <Pill tone="active" data-r style={stagger(0)}>
        {eyebrow}
      </Pill>
      <h2 className="h2" data-r style={stagger(1)}>
        {title}
      </h2>
      {sub ? (
        <p className="sub" data-r style={stagger(2)}>
          {sub}
        </p>
      ) : null}
    </div>
  );
}
